import React, { useLayoutEffect, useState } from 'react';

interface DOMModalContextProps {
	toggleId: string;
	children: React.ReactElement;
}

interface DOMModalContextProviderProps {
	opened: boolean;
	toggleId: string | undefined;
}

const DOMModalContext = React.createContext<DOMModalContextProviderProps>({
	opened: false,
	toggleId: undefined,
});

export function DOMModalContextProvider(props: DOMModalContextProps) {
	const { children, toggleId } = props;
	const [opened, setOpened] = useState(false);

	useLayoutEffect(() => {
		const toggler = document.querySelectorAll(
			`[data-react-modal-toggleId="${toggleId}"]`,
		);

		if (toggler.length) {
			for (const item of toggler) {
				item.addEventListener('click', e => {
					setOpened(true);
				});
			}
		}
	}, [toggleId]);

	return (
		<DOMModalContext.Provider
			value={{
				opened,
				toggleId,
			}}>
			{React.cloneElement(children, {
				...children.props,
				opened,
				onClose: () => {
					setOpened(false);
				},
			})}
		</DOMModalContext.Provider>
	);
}
